import { t } from '@lingui/core/macro';
import { PaymentOption } from '@navio/nsdk';
import { NoddiCard, NoddiSelectionCardGroup } from 'noddi-ui-web';

type Props = {
  paymentOption: PaymentOption;
  onSelect: (paymentOption: PaymentOption) => void;
  invoiceRecipientName: string;
};

export const StationaryPaymentChoice = ({ paymentOption, onSelect, invoiceRecipientName }: Props) => {
  return (
    <NoddiCard>
      <fieldset className='m-0 flex min-w-0 flex-col gap-2 border-0 p-0'>
        <legend className='mb-2 text-lg leading-none font-semibold'>{t`Payment`}</legend>
        <NoddiSelectionCardGroup
          size='small'
          options={[
            {
              value: PaymentOption.INVOICE,
              label: t`Invoice`,
              description: t`Invoiced to ${invoiceRecipientName}`,
              icon: 'FileText'
            },
            { value: PaymentOption.PAY_BEFORE, label: t`Pay now`, icon: 'CreditCard' }
          ]}
          value={paymentOption}
          onValueChange={onSelect}
        />
      </fieldset>
    </NoddiCard>
  );
};
